/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_common_download = /** @type {(inputs: {}) => string} */ () => {
	return `Descargar`
};

const en_common_download = /** @type {(inputs: {}) => string} */ () => {
	return `Download`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const common_download = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.common_download(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("common_download", locale)
	if (locale === "es") return es_common_download(inputs)
	return en_common_download(inputs)
};
export { common_download as "common.download" }